import React, { useEffect, useMemo, useState,useCallback } from "react";
import PageTitle from "../../layouts/PageTitle";
import { ToastContainer } from "react-toastify";
import { Badge, Button } from "react-bootstrap";
import Table from "../../components/table/ReactTable/Table";
import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { useDispatch, useSelector } from "react-redux";
import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { productStockAction } from "../../../_store/productStock.slice";

function ProductStockReport() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const dispatch = useDispatch();
  const productStockReport = useSelector(
    (x) => x?.productStock?.stockProductList
  );

  const [finalTableData, setFinalTableData] = useState([]);
    const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);

  useEffect(() => {
    showLoader();
    dispatch(productStockAction.getStockProductList());
  }, []);

  const PRODUCTS_REPORT_COLUMNS = [
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Category",
      Footer: "Category",
      accessor: "CategoryName",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "left",
      Filter: ColumnFilter,
    },
    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "left",
      Filter: ColumnFilter,
    },

    {
      Header: "Stock Quantity",
      Footer: "Stock Quantity",
      accessor: "StockQuantity",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Cost",
      Footer: "Cost",
      accessor: "CostStr",
      justify: "right",
      Filter: ColumnFilter,
    },
    {
      Header: "Cost Total",
      Footer: "Cost Total",
      accessor: "CostTotalStr",
      justify: "right",
      Filter: ColumnFilter,
    },
    {
      Header: "G-Partner Price",
      Footer: "G-Partner Price",
      accessor: "GPARTNERPriceStr",
      justify: "right",
      Filter: ColumnFilter,
    },
    {
      Header: "Price Total",
      Footer: "Price Total",
      accessor: "GPartnerTotalStr",
      justify: "right",
      Filter: ColumnFilter,
    },
  ];
  const columns = useMemo(() => PRODUCTS_REPORT_COLUMNS, []);

  const generateColumns = [
    {
      header: "Warehouse",
      dataKey: "WareHouseNumber",
    },
    {
      header: "Category",
      dataKey: "CategoryName",
    },
    {
      header: "Product Name",
      dataKey: "ProductName",
    },
    {
      header: "SKU",
      dataKey: "SKU",
    },
    {
      header: "Stock Quantity",
      dataKey: "StockQuantity",
    },

    {
      header: "Cost",
      dataKey: "CostStr",
    },
    {
      header: "Cost Total",
      dataKey: "CostTotalStr",
    },
    {
      header: "G-Partner Price",
      dataKey: "GPARTNERPriceStr",
    },
    {
      header: "Price Total",
      dataKey: "GPartnerTotalStr",
    },
  ];

  const handleClickPDF = () => {
    let title = "Product Stock Report";
    const columnStyles = {
      WareHouseNumber: { halign: "center", cellWidth: 20 },
      CategoryName: { halign: "left", cellWidth: 35 },
      ProductName: { halign: "left", cellWidth: 40 },
      SKU: { halign: "left", cellWidth: 35 },
      StockQuantity: { halign: "center", cellWidth: 26 },
      CostStr: { halign: "right", cellWidth: 26 },
      CostTotal: { halign: "right", cellWidth: 26 },
      GPARTNERPriceStr: { halign: "right", cellWidth: 26 },
      GPartnerTotal: { halign: "right", cellWidth: 26  },
    };
   
      generatePDF(
        finalTableData,
        generateColumns,
        true,
        title,
        columnStyles
      );
   
  };

  const handleClickExcel = () => {
    let title = "Product Stock Reports";
    let generateExcelColumns = [
      "Warehouse",
      "Category",
      "Product Name",
      "SKU",
      "Stock Quantity",
      "Cost",
      "Cost Total",
      "G-Partner Price",
      "Price Total",
    ];
    let new_productReports =
      finalTableData &&
      finalTableData?.map(function (obj) {
        return {
          WareHouseNumber: obj.WareHouseNumber,
          CategoryName: obj.CategoryName,
          ProductName: obj.ProductName,
          SKU: obj.SKU,
          StockQuantity: obj.StockQuantity,
          Cost: obj.Cost,
          CostTotal: obj.CostTotal,
          GPartnerPrice: obj.GPARTNERPrice,
          PriceTotal: obj.GPartnerTotal,
        };
      });

    generateXlsx(new_productReports, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Product Stock Report" motherMenu="Accountant" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Product Stock Report</h4>
          <div className="float-sm-end">
            {productStockReport && productStockReport.length > 0 && (
              <>
                <Button
                  className="me-2"
                  variant="danger btn-rounded"
                  onClick={handleClickPDF}
                >
                  <span className="btn-icon-start text-danger">
                    <i className="fa fa-solid fa-file-pdf"></i>
                  </span>
                  PDF
                </Button>
                <Button
                  className="me-2"
                  variant="secondary btn-rounded"
                  onClick={handleClickExcel}
                >
                  <span className="btn-icon-start text-secondary">
                    <i className="fa fa-regular fa-file-excel"></i>
                  </span>
                  Excel
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <Table columns={columns} data={productStockReport} onDataUpdate={handleTableDataUpdate} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductStockReport;
